import { apiClient } from "@/lib/api/client";

export type OrganizationTagDto = {
  id: string;
  name: string;
  slug: string;
  color: string | null;
  description: string | null;
  is_active: boolean;
  created_at: string;
  updated_at: string;
};

export type OrganizationRecordDto = {
  id: string;
  tenant_id: string | null;
  name: string;
  code: string | null;
  type: string;
  parent_id: string | null;
  contact_email: string | null;
  phone: string | null;
  website: string | null;
  assignee_name: string | null;
  assignee_email: string | null;
  is_active: boolean;
  tags: OrganizationTagDto[];
  created_at: string;
  updated_at: string;
};

export type OrganizationsListResponse = {
  items: OrganizationRecordDto[];
  total: number;
};

export type OrganizationListOptions = {
  search?: string | null;
};

export async function listOrganizations(options: OrganizationListOptions = {}): Promise<OrganizationsListResponse> {
  const params = options.search?.trim() ? { search: options.search.trim() } : undefined;
  const { data } = await apiClient.get<OrganizationsListResponse>("/organizations", {
    params,
  });
  return data;
}

export type OrganizationCreateBody = {
  name: string;
  type?: string;
  parent_id?: string | null;
  contact_email?: string | null;
  phone?: string | null;
  website?: string | null;
  assignee_name?: string | null;
  assignee_email?: string | null;
  is_active?: boolean;
  tag_ids?: string[];
  new_tags?: string[];
  first_location?: {
    name?: string | null;
    address_line_1: string;
    address_line_2?: string | null;
    city: string;
    state_id: string;
    pincode: string;
    is_primary?: boolean;
    note?: string | null;
  } | null;
};

export type OrganizationUpdateBody = Partial<OrganizationCreateBody>;

export async function createOrganization(body: OrganizationCreateBody): Promise<OrganizationRecordDto> {
  const { data } = await apiClient.post<OrganizationRecordDto>("/organizations", body);
  return data;
}

export async function updateOrganization(organizationId: string, body: OrganizationUpdateBody): Promise<OrganizationRecordDto> {
  const { data } = await apiClient.put<OrganizationRecordDto>(`/organizations/${organizationId}`, body);
  return data;
}

export async function deleteOrganization(organizationId: string): Promise<void> {
  await apiClient.delete(`/organizations/${organizationId}`);
}

export type IndianStateDto = {
  id: string;
  name: string;
  code: string;
  type: "state" | "union_territory" | string;
  is_active: boolean;
  sort_order: number;
};

export async function listIndianStates(): Promise<IndianStateDto[]> {
  const { data } = await apiClient.get<IndianStateDto[]>("/organizations/reference/indian-states");
  return data;
}

export async function listOrganizationTags(): Promise<OrganizationTagDto[]> {
  const { data } = await apiClient.get<OrganizationTagDto[]>("/organizations/tags");
  return data;
}
